import styled from "styled-components"

import { SimpleLineChart } from "components/common/SimpleLineChart"

import type { TrendDirection } from "../MonthlyEngagementPage/types"

const TrendChart = styled.div`
  position: absolute;
  right: 20px;
  bottom: 0;
  width: calc(74% - 20px);
  height: 82px;
  padding-bottom: 18px;
  box-sizing: border-box;
  pointer-events: none;
`

const getTrendColor = (direction: TrendDirection) => {
  if (direction === "down") return "#ef4444"
  if (direction === "flat") return "#22d3ee"
  return "#22c55e"
}

interface TrendSparklineProps {
  labels?: string[]
  values?: number[]
  direction?: TrendDirection
}

export const getSparklineValues = (values?: number[], pointCount = 4) => {
  if (values?.length) {
    return values
  }

  return Array.from({ length: pointCount }, () => 0)
}

export const getSparklineLabels = (labels: string[] | undefined, pointCount: number) => {
  if (labels?.length === pointCount) {
    return labels
  }

  return Array.from({ length: pointCount }, (_, index) => `W${index + 1}`)
}

export const TrendSparkline = ({
  labels = ["W1", "W2", "W3", "W4"],
  values,
  direction = "up",
}: TrendSparklineProps) => {
  const pointCount = values?.length || labels.length || 4
  const sparklineValues = getSparklineValues(values, pointCount)
  const sparklineLabels = getSparklineLabels(labels, pointCount)

  return (
    <TrendChart aria-hidden="true">
      <SimpleLineChart data={sparklineValues} labels={sparklineLabels} color={getTrendColor(direction)} />
    </TrendChart>
  )
}
